
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/400w-rigid-solar-panel",
      function () {
        return require("private-next-pages/400w-rigid-solar-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/400w-rigid-solar-panel"])
      });
    }
  